import React from "react"
import { FormButton } from "../members/formComponents/FormButton"
import { FormInput } from "../members/formComponents/FormInput"
import { Container, Form, Input } from "reactstrap"
import validateInput from "../../view/shared/validations/validateOtherIncome"
import { connect } from "react-redux"
import { Trans, useLingui } from "@lingui/react"
import { Redirect } from "react-router-dom"
import { toast } from "react-toastify"
import PropTypes from "prop-types"
import { WarningMessage } from "../../view/shared/notifications/Notifications"
import { initiateTransaction } from "../../store/reducers/transactions/actions"
import { setCurrentPage } from "../../store/reducers/navigation"
import StellarLoader from "../layout/StellarLoader"
import { t } from "@lingui/macro"
import { db } from "../../view/shared/utilities/cache"
import { useLiveQuery } from "dexie-react-hooks"

const accounts = ["fine", "welfare", "savings"]
const notify = (msg) => toast(msg)

const radioTextStyle = {
  fontFamily: "Fira Sans",
  fontSize: "20px",
  marginLeft: "10px", // Reduced margin for better alignment
  marginRight: "20px", // Add some space after the text
  verticalAlign: "middle", // Align text with the radio button
}

const radioInputStyle = {
  width: "20px", // Increase size of the radio button
  height: "20px",
  verticalAlign: "middle",
}

const subheaderStyle = {
  fontFamily: "Fira Sans",
  fontSize: "20px",
  textAlign: "left",
  lineHeight: "1.5em",
}
const OtherIncomeAndExpenses = (props) => {
  const { i18n } = useLingui()

  const redirectBack = () => {
    props.setPage("group-memberActions")
  }

  const [state, setState] = React.useState({
    amount: props.amount,
    destination: props.destination,
    sourceFundType: props.sourceFundType,
    otherType: props.otherType,
    loading: false,
    redirect: false,
    errors: {},
    fundError: false,
  })

  const onChange = (e) => {
    setState({
      ...state,
      errors: { [e.target.name]: null, fundError: false },
    })
    setState({ ...state, [e.target.name]: e.target.value })
  }

  const isValid = () => {
    const { errors, isValid } = validateInput(state)

    if (!isValid) {
      setState({ ...state, errors })
    }

    return isValid
  }

  const onSubmit = (e) => {
    e.preventDefault()
    const account = state.sourceFundType;

    // --- Offline Balance Validation ---
    if (props.balances && props.balances[account]) {
      if (props.balances[account].balance < state.amount) {
        setState({ ...state, fundError: true });
        return;
      }
    }
    // --- End Validation ---

    if (isValid()) {
      setState({ ...state, errors: {} })
      processTransaction(
        state.amount,
        state.sourceFundType,
        state.destination,
        state.otherType,
      )
      setState({ ...state, amount: "" })
    }
  }

  const processTransaction = (amount, source, destination, otherType) => {
    const lang_code = i18n.locale

    const lang = {
      fr: {
        message: `Confirmer la soumission de ${state.amount} à ${source} pour le membre`,
      },
      en: {
        message: `Confirm  submission of ${state.amount} to ${source} for member`,
      },
      sw: {
        message: `Thibitisha uwasilishaji wa kiasi cha hela ${state.amount} kwa mwanachama akaunti ya ${source}`,
      },
      es: {
        message: `Confirm  submission of ${state.amount} to ${source} for member`,
      },
      lb: {
        message: `Confirm  submission of ${state.amount} to ${source} for household`,
      },
      pt: {
        message: `Confirm  submission of ${state.amount} to ${source} for member`,
      },
      ar: {
        message: `الاسرة ${source} في الحساب ${state.amount} أكد إيداع `,
      },
    }

    const uuid = props.currentMember?.pubkey
    const meetingId = props.ongoingMeeting?.id ? props.ongoingMeeting?.id : props.ongoingMeeting?.cacheId

    if (window.confirm(lang[lang_code].message)) {
      setState({ ...state, loading: true })
      props.commitTransaction(
        {
          uid: uuid,
          type: ["other income", "group income"].includes(otherType.toLowerCase())
            ? "GROUP_INCOME"
            : "GROUP_EXPENSE",
          fund: source,
          amount: parseFloat(amount),
          ...(props.currentMember?.id ? {
            member_id: props.currentMember?.id,
          } : {
            memberCacheId: props.currentMember?.cacheId || props.currentMember?.pubkey
          })
        },
      )

      notify(<WarningMessage msg={"Processing Transaction"} />)
      setState({ ...state, loading: false })
      redirectBack()
    } else {
      notify(<WarningMessage />)
    }
  }

  const groupAccounts = () => props.group.funds.map((item) => item.type)

  if (state.redirect) {
    return (
      <Redirect
        to={{
          pathname: `/Groups/${props.vsla?.id}/members/${props.currentMember.blockchain_wallet_id}/Actions`,
          state: { vsla_id: props.vsla?.id },
        }}
      />
    )
  }

  if (state.loading) {
    return <StellarLoader />
  }

  return (
    <Container>
      <Form onSubmit={onSubmit}>
        <Container>
          <span style={{ color: "red" }}>{state.errors.amount}</span>
          {state.fundError && (
            <span
              style={{
                color: "red",
              }}
            >
              Insufficient funds
            </span>
          )}

          <FormInput
            type="number"
            name="amount"
            placeholder={t({ id: "Amount" })}
            value={state.amount || ""}
            onChange={onChange}
            className="form-control"
          />
          <span style={subheaderStyle}>
            <Trans id="select.fund">Select Fund</Trans>
          </span>
          <Container>
            <span style={{ color: "red" }}>{state.errors.sourceFundType}</span>
            <br />
            <Container style={{ display: "grid" }}>
              {accounts.map((acc) => (
                <>
                  {acc === "welfare" && groupAccounts()?.includes(acc) && (
                    <span>
                      <Input
                        name="sourceFundType"
                        type="radio"
                        id="welfare"
                        style={radioInputStyle}
                        onChange={onChange}
                        value="welfare"
                      />
                      <span style={radioTextStyle}>
                        <Trans id="welfare">Welfare</Trans>
                      </span>
                    </span>
                  )}
                  {acc === "savings" && groupAccounts().includes(acc) && (
                    <span>
                      <Input
                        name="sourceFundType"
                        type="radio"
                        id="savings"
                        style={radioInputStyle}
                        onChange={onChange}
                        value="savings"
                      />
                      <span style={radioTextStyle}>
                        <Trans id="savings">Savings</Trans>
                      </span>
                    </span>
                  )}
                  {acc === "fine" && groupAccounts()?.includes(acc) && (
                    <span>
                      <Input
                        name="sourceFundType"
                        type="radio"
                        id="fine"
                        style={radioInputStyle}
                        onChange={onChange}
                        value="fine"
                      />
                      <span style={radioTextStyle}>
                        <Trans id="fine">Fine</Trans>
                      </span>
                    </span>
                  )}
                </>
              ))}
            </Container>
          </Container>
          <br />
          <FormButton
            type={"submit"}
            value="Submit"
            name="submit"
            className="btn btn-lg form-control"
            disabled={!state.amount}
          />
        </Container>
      </Form>
    </Container>
  )
}

OtherIncomeAndExpenses.propTypes = {
  destination: PropTypes.string.isRequired,
  vsla: PropTypes.object,
  setPage: PropTypes.func,
  amount: PropTypes.string,
  sourceFundType: PropTypes.string,
  otherType: PropTypes.string,
  currentMember: PropTypes.object,
  commitTransaction: PropTypes.func,
  ongoingMeeting: PropTypes.array,
  group: PropTypes.object,
}

const mapDispatchToProps = (dispatch) => ({
  setPage: (page) => dispatch(setCurrentPage(page)),
  commitTransaction: (data, meeting) => dispatch(initiateTransaction(data, meeting)),
})

const mapStateToProps = (state) => {
  const { account, accountV2 } = state;

  const selectBalances = () => {
    if (accountV2.offline) {
      return accountV2.offline.balances;
    }
    return account.balances;
  };

  return {
    ongoingMeeting: state.meeting?.ongoing,
    currentMember: state.loadedMember,
    vsla: state.vsla,
    group: state.group,
    balances: selectBalances(), // Add the balances selector
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OtherIncomeAndExpenses)
